import AddressFormatterFunctional from 'src/components/Layouts/AddressFormatterFunctional';
import i18n from 'src/i18n';
import Tables from 'src/class/Tables';

const configTable = () => {
  const Table = { ...Tables.Table };
  Table.tableColumns = [
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'tradename',
      label: i18n.t('common_words.comercial_name'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'nit',
      label: 'NIT',
      minWidth: 150,
      sortable: true,
      align: 'center',
    },
    {
      prop: 'address',
      label: i18n.t('common_words.location'),
      minWidth: 250,
      formatter: AddressFormatterFunctional,
    },
    {
      prop: 'email',
      label: i18n.t('common_words.email'),
      minWidth: 200,
      sortable: true,
    },
    {
      prop: 'comercial_activity',
      label: i18n.t('common_words.comercial_activity'),
      minWidth: 200,
      sortable: true,
    },
  ];

  const search = { ...Tables.Search };

  return { Table, search };
};
export default configTable;
